import { create } from 'zustand';
import api from '../utils/api';

const useAuthStore = create((set) => ({
  user: null,
  token: localStorage.getItem('access_token'),
  isLoading: false,
  isAuthenticated: !!localStorage.getItem('access_token'),

  login: async (email, password) => {
    set({ isLoading: true });
    try {
      const res = await api.post('/auth/login', { email, password });
      // 2FA enabled → an OTP was emailed; caller must verify before tokens.
      if (res.data?.require_otp) {
        set({ isLoading: false });
        return { success: true, requireOtp: true, email: res.data.email || email };
      }
      const { access_token, refresh_token } = res.data;
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('refresh_token', refresh_token);
      set({ token: access_token, isAuthenticated: true, isLoading: false });
      return { success: true };
    } catch (err) {
      set({ isLoading: false });
      return {
        success: false,
        error: err.response?.data?.detail || 'Login failed!'
      };
    }
  },

  resendOtp: async (email) => {
    try {
      await api.post('/auth/resend-otp', { email });
      return { success: true };
    } catch (err) {
      return { success: false, error: err.response?.data?.detail || 'Could not resend code' };
    }
  },

  verifyOtp: async (email, otp) => {
    set({ isLoading: true });
    try {
      const res = await api.post('/auth/verify-otp', { email, otp });
      const { access_token, refresh_token } = res.data;
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('refresh_token', refresh_token);
      set({ token: access_token, isAuthenticated: true, isLoading: false });
      return { success: true };
    } catch (err) {
      set({ isLoading: false });
      return {
        success: false,
        error: err.response?.data?.detail || 'Verification failed!'
      };
    }
  },

  register: async (data) => {
    set({ isLoading: true });
    try {
      await api.post('/auth/register', data);
      set({ isLoading: false });
      return { success: true };
    } catch (err) {
      set({ isLoading: false });
      return {
        success: false,
        error: err.response?.data?.detail || 'Registration failed!'
      };
    }
  },

  logout: () => {
    localStorage.clear();
    set({ user: null, token: null, isAuthenticated: false });
    window.location.href = '/login';
  },

  fetchUser: async () => {
    try {
      const res = await api.get('/user/dashboard');
      set({ user: res.data });
      return res.data;
    } catch (err) {
      console.error(err);
    }
  },
}));

export default useAuthStore;
